import * as React from 'react';
import { cn } from '@companion-professional/webutils';

export const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('text-md text-muted-foreground', className)} {...props} />
  )
);
CardDescription.displayName = 'CardDescription';
